import { Box } from "@mui/material";
import ElderlyOutlinedIcon from "@mui/icons-material/ElderlyOutlined";
import AccessibleIcon from "@mui/icons-material/Accessible";

export interface ITkInquiryTableListProps {
  title: string; // タイトル
  elderly?: boolean; // 介護マーク
  accessible?: boolean; // 障害マーク
  keyword: string; // key
  text?: any; // 値
  fill?: boolean; // 網掛け
}
interface ITkInquiryTableProps {
  list: ITkInquiryTableListProps[][];
}

const TkInquiryTable: React.FC<ITkInquiryTableProps> = (props) => {
  const { list } = props;

  return (
    <Box className="tkInquiryTable">
      {list.map((item, index) => (
        <Box
          className={`table ${item.length === 1 ? "single" : ""}`}
          key={index}
        >
          {item.map((d, i) => (
            <Box className="tableLine" key={`${index}-${i}`}>
              <Box className="tableTitle">
                {d.title}
                {d.elderly && <ElderlyOutlinedIcon fontSize="large" />}
                {d.accessible && <AccessibleIcon fontSize="large" />}
              </Box>

              <Box
                className={`tableText ${
                  d.fill
                    ? d.keyword === "contractorNo" || d.keyword === "corpName"
                      ? "colored_c"
                      : d.keyword === "facilityNo" ||
                        d.keyword === "facilityName"
                      ? "colored_f"
                      : ""
                    : ""
                }`}
              >
                {d.text}
              </Box>
            </Box>
          ))}
        </Box>
      ))}
    </Box>
  );
};

export default TkInquiryTable;
